(() => {
  if (customElements.get('slider-brands')) {
    return;
  }

  class SliderBrands extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        enabled: true,
        loop: true,
        slidesPerView: 1.73,
        grabCursor: true,
        spaceBetween: 16,
        breakpoints: {
          481: {
            slidesPerView: 2.73,
            spaceBetween: 16,
          },
          768: {
            enabled: false,
            spaceBetween: 0,
          },
        },
      };

      this.options.autoplay = {
        loop: true,
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        waitForTransition: false,
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this, this.options);
    }
  }

  customElements.define('slider-brands', SliderBrands);
})();
